<template>
  <v-row>
    <v-col
      sm="1"
      lg="2"
      class="hidden-xs-only"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            small
            fixed
            color="primary"
            v-bind="attrs" 
            v-on="on" 
            @click="regresar"
          >
            <v-icon>
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>Regresar</span>
      </v-tooltip>
    </v-col>
    <v-col 
      cols="12" 
      sm="10" 
      lg="8"
    >
      <DetailCard
        title="Detalles Usuario"
        :loading="cardLoading"
      >
        <v-row justify="center">
          <v-col
            v-for="(item, index) in usuario" 
            :key="index"
            cols="12" 
            sm="10" 
            lg="8"
          >
            <p class="text-h6 font-weight-bold">
              {{ item.label }}
            </p>
            <template v-if="item.value != ''">
              <p class="text-subtitle-1">
                {{ item.value }}
              </p>
            </template>
            <template v-else>
              <p class="text-subtitle-1">
                No registrado
              </p>
            </template>
          </v-col>
        </v-row>
      </DetailCard>
    </v-col>
  </v-row>
</template>
<script>
import DetailCard from '../../../components/admin/DetailCard.vue';

export default {
  data: () => ({
    cardLoading: true
  }),

  components: {
    DetailCard
  },

  mounted() {
    this.$store.dispatch("detallesUsuario", this.$route.params.id_usuario)
    setTimeout(() => {
      this.cardLoading = false
    }, 1000)
  },

  computed: {
    usuario () {
      const detallesUsuario = this.$store.getters.obtenerUsu

      return [
        {
          label: "Identificación",
          value: detallesUsuario.identificacion
        },

        {
          label: "Nombres",
          value: detallesUsuario.nombres
        },

        {
          label: "Apellidos",
          value: detallesUsuario.apellidos
        },

        {
          label: "Teléfono",
          value: detallesUsuario.telefono
        },

        {
          label: "Correo Electrónico",
          value: detallesUsuario.correo
        },
        
        {
          label: "Regional",
          value: detallesUsuario.regional
        },

        {
          label: "Centro de Formación",
          value: detallesUsuario.centro_formacion
        },

        {
          label: "Perfiles",
          value: detallesUsuario.perfiles
        },
      ]
    }
  },

  methods: {
    regresar() {
      this.$router.back()
    }
  }
}
</script>